import "leaflet/dist/leaflet.css";
import "./styles.css";
import { registerSW } from "virtual:pwa-register";
import { loadMe, renderAuth, type Me } from "./auth";
import { renderGardens, refreshGardens } from "./gardens";
import { renderGarden } from "./garden";
import { post } from "./api";
import * as store from "./store";
import { syncSoon } from "./sync";
import { toast } from "./util";
import { DEMO_USER, demoGarden, demoPlants, demoSubgarden, demoSubgardenPlants, isDemo, startDemoMode } from "./demo";
import type { Garden } from "./types";

const root = document.getElementById("app")!;

window.addEventListener("vite:preloadError", () => {
  location.reload();
});

registerSW({
  immediate: true,
  onRegisteredSW(_url, r) {
    void r?.update();
  },
  onOfflineReady() {
    toast("Aplikace je připravená i pro offline.");
  },
});

async function start() {
  const resetToken = /#reset=([\w-]+)/.exec(location.hash)?.[1];
  const me = await loadMe();
  if (resetToken || !me.user) {
    renderAuth(root, (u) => showGardens(u), { registration: me.registration, resetToken, onDemo: startDemo });
    return;
  }
  void syncSoon();
  const lastId = localStorage.getItem("zahrada:garden");
  const gardens = await store.gardens();
  const last = gardens.find((g) => g.id === lastId);
  if (last) openGarden(me.user, last); else showGardens(me.user);
}

async function startDemo() {
  startDemoMode();
  store.useMemory();
  const g = demoGarden();
  await store.putGarden(g);
  for (const t of demoPlants(g.id)) await store.putPlant(t);
  const sub = await demoSubgarden(g.id);
  await store.putGarden(sub);
  for (const t of demoSubgardenPlants(sub.id)) await store.putPlant(t);
  openGarden(DEMO_USER, g);
  toast("Ukázka: nic se neukládá, po odchodu vše zmizí.", 4000);
}

function showGardens(me: Me) {
  if (!isDemo()) { try { localStorage.removeItem("zahrada:garden"); } catch {} }
  void renderGardens(root, me, { open: (g, edit) => openGarden(me, g, edit), logout });
}

function openGarden(me: Me, g: Garden, editParcels = false) {
  if (!isDemo()) { try { localStorage.setItem("zahrada:garden", g.id); } catch {} }
  void renderGarden(root, g, me, { back: () => showGardens(me), logout, openGarden: (g2, edit) => openGarden(me, g2, edit) }, editParcels);
  void refreshGardens();
}

async function logout() {
  if (isDemo()) { location.reload(); return; }
  const pending = await store.pendingCount();
  if (pending && !confirmInline(pending)) return;
  try { await post("/api/auth/logout"); } catch {}
  await store.wipeAll();
  try { localStorage.removeItem("zahrada:user"); localStorage.removeItem("zahrada:garden"); } catch {}
  location.reload();
}

let logoutArmed = 0;
function confirmInline(pending: number) {
  if (Date.now() - logoutArmed < 5000) return true;
  logoutArmed = Date.now();
  toast(pending + " změn ještě není odesláno. Odhlášení je smaže. Pro odhlášení klepni znovu.", 5000);
  return false;
}

void start();